module.exports = __webpack_public_path__ + "img/undo.9f95a9a1.svg";